export const lang = [
  { name: "TW", lang: "zh-TW" },
  // { name: "CN", lang: "zh-CN" },
  // { name: "JP", lang: "ja-JP" },
  { name: "EN", lang: "en-US" },
];

export const tab = [
  { name: "About", to: "about" },
  { name: "Product", to: "AllProduct" },
  { name: "News", to: "news" },
  //{ name: "Training", to: "Training"},
  // { name: "Chat", to: "Chat"},
  { name: "Member", to: "member" },
  { name: "Institute", to: "institute" },
  { name: "Contact", to: "#contact" },
];